import { useRef } from "react"
import dynamic from "next/dynamic"
import ReCAPTCHA from "react-google-recaptcha"
import { useRouter } from "next/router"
import { useArchiveContext } from "@/lib/contexts/archiveContext-2"
import { tickSearchClick } from "@/lib/api/search"
import Block from "@/components/wrappers/block"

const Views = {
  grid: dynamic(() => import("@/blocks/archive/view/views/grid")),
  map: dynamic(() => import("@/blocks/archive/view/views/map"))
}

export default function View({ block }) {
  const store = useArchiveContext()
  const router = useRouter()
  const recaptchaRef = useRef()
  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY
  const currentView = store.getView()
  const View = Views[currentView] ?? null

  const trackClick = async (e, url) => {
    e.preventDefault()
    const captcha = await recaptchaRef.current.executeAsync()
    tickSearchClick(captcha, store?.hash)
    router.push(url)
  }

  if (View === null) {
    return View
  }

  return (
    <Block block={block}>
      <ReCAPTCHA
        className="hidden"
        ref={recaptchaRef}
        size="invisible"
        sitekey={siteKey}
      />
      <View {...{ block, trackClick }} />
    </Block>
  )
}
